import type { Response } from '@/types/http'
import type { IndexInfoAggRes, UserCenterRequest } from '@/types/info'
import { http } from '@/utils/http'

const DEFAULT_USER_CENTER_REQUEST: UserCenterRequest = {
  myCollectGame: {
    size: 10,
    current: 1
  },
  orderPage: {
    model: {
      bonusTypeList: [],
      receiveStatus: 0
    },
    size: 10
  },
  orderCount: {}
}

export const getIndexInfoAgg = (body: UserCenterRequest = DEFAULT_USER_CENTER_REQUEST) => {
  return http<Response<IndexInfoAggRes>>('/app-api/member/info/agg', {
    method: 'post',
    body,
    noMsg: true
  })
}
